import { type PropsWithChildren } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import type { Stripe, StripeElementsOptions } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { CONFIG } from '@frameio/config';
import { useStripeElementsOptions } from '../utils/stripeElementStyles';

let stripePromise: Promise<Stripe | null>;
// disable advanced fraud signals
// https://stripe.com/docs/disputes/prevention/advanced-fraud-detection
loadStripe.setLoadParameters({ advancedFraudSignals: false });
const getStripe = (): Promise<Stripe | null> => {
  if (!CONFIG.thirdParty.stripePublishableKey) {
    return Promise.resolve(null);
  }

  if (stripePromise) {
    return stripePromise;
  }
  stripePromise = loadStripe(CONFIG.thirdParty.stripePublishableKey, {
    betas: ['elements_tax_id_1'],
  });
  return stripePromise;
};

export default function CardFormContainer({
  children,
}: PropsWithChildren<object>) {
  const options: StripeElementsOptions = useStripeElementsOptions();

  return (
    <Elements options={options} stripe={getStripe()}>
      {children}
    </Elements>
  );
}
